export const en = {
  common: {
    getInTouch: "Get in Touch",
    requestQuote: "Request a Quote",
    inEuropeAndUK: "In Europe and the UK",
  },
  nav: {
    about: "About",
    services: "Services",
    fleet: "Fleet",
    contact: "Contact",
  },
  hero: {
    tagline: "Trusted Transport and Logistics Partner in Europe",
    deliveryTime: "Delivery Time: 24-48 Hours",
    features: {
      fastDelivery: {
        title: "Fast",
        description: "24-48 hour delivery across Europe and the UK",
      },
      tracking: {
        title: "Real-Time Tracking",
        description: "Track your shipment in real-time",
      },
      storage: {
        title: "Secure",
        description: "Safe and secure storage solutions",
      },
      partners: {
        title: "Trusted",
        description: "Working with industry leaders",
      },
      experts: {
        title: "Experts",
        description: "Professionals with extensive experience",
      },
    },
  },
  about: {
    title: "Who We Are",
    description:
      "With 30 years of experience in transport and logistics, we deliver trusted freight and shipping solutions across Europe and the UK. Based in Arad, Romania, we're your reliable partner for seamless logistics.",
    info: {
      location: {
        title: "Location",
        description: "Arad, Romania",
      },
      experience: {
        title: "Experience",
        description: "30+ Years in Transport",
      },
    },
    features: {
      reliability: {
        title: "Reliability",
        description:
          "Count on our 30 years of experience for dependable transport solutions.",
      },
      efficiency: {
        title: "Efficiency",
        description: "Fast and efficient delivery across Europe and the UK.",
      },
      safety: {
        title: "Safety",
        description: "Your cargo is in safe hands with our experienced team.",
      },
      expertise: {
        title: "Expertise",
        description: "Professional logistics solutions tailored to your needs.",
      },
    },
  },
  services: {
    title: "What We Do",
    description:
      "We provide comprehensive logistics, transport, and storage services for businesses and private individuals across Europe and the UK. From freight transport to secure storage, we ensure efficient and reliable delivery.",
    road: {
      title: "Road Transport",
      description:
        "Efficient and reliable freight transport services across Europe and the UK.",
    },
    express: {
      title: "Express Delivery",
      description: "Fast and secure delivery for time-sensitive shipments.",
    },
    warehousing: {
      title: "Storage Solutions",
      description: "Secure storage facilities for your goods and merchandise.",
    },
    international: {
      title: "International Logistics",
      description:
        "Comprehensive logistics solutions for international shipping.",
    },
  },
  fleet: {
    title: "Our Fleet",
    description:
      "Our modern fleet meets Euro 6 standards, featuring vehicles from 22 to 40 tons. We're equipped to handle all your transport needs across Europe and the UK.",
    euro6Compliant: "Euro 6 compliant vehicles",
    vehicles: {
      truck: {
        title: "Heavy Trucks",
        description: "Modern heavy-duty trucks for long-distance transport.",
      },
      van: {
        title: "Delivery Vans",
        description: "Efficient vans for local and regional deliveries.",
      },
      trailer: {
        title: "Trailers",
        description: "Versatile trailers for various cargo types.",
      },
      specialized: {
        title: "Specialized Vehicles",
        description: "Custom vehicles for specific transport needs.",
      },
    },
    brands: {
      title: "Our Vehicle Brands",
    },
  },
  partners: {
    title: "Our Partners",
    description:
      "We work with leading companies across various industries to provide comprehensive logistics solutions.",
    types: {
      manufacturing: {
        title: "Manufacturing",
        description:
          "Supporting production and assembly operations with reliable transport solutions.",
      },
      industrial: {
        title: "Industrial",
        description:
          "Serving heavy industries with specialized transport and logistics services.",
      },
      retail: {
        title: "Retail",
        description:
          "Ensuring timely delivery of goods to retail locations across Europe.",
      },
      logistics: {
        title: "Logistics",
        description:
          "Collaborating with logistics providers for end-to-end supply chain solutions.",
      },
    },
    logos: {
      title: "Our Trusted Partners",
    },
  },
  perks: {
    title: "Why Choose Us",
    description:
      "Enjoy real-time tracking, reliable services, and express distribution for seamless transport and logistics across Europe and the UK. We prioritize efficiency and customer satisfaction.",
    items: {
      speed: {
        title: "Fast Delivery",
        description: "24-48 hour delivery across Europe and the UK.",
      },
      safety: {
        title: "Secure Transport",
        description:
          "Your cargo is protected with our comprehensive insurance.",
      },
      coverage: {
        title: "Wide Coverage",
        description: "Extensive network across Europe and the UK.",
      },
      expertise: {
        title: "Expert Team",
        description: "Professional staff with years of experience.",
      },
    },
  },
  quote: {
    title: "Request a Quote",
    description:
      "Time is precious. Get a quote for fast, reliable transport and logistics services across Europe and the UK today.",
    button: "Get a Quote",
  },
  contact: {
    title: "Contact Us",
    description:
      "Reach out to us for expert transport and logistics services across Europe and the UK.",
    phone: {
      title: "Phone",
    },
    email: {
      title: "Email",
    },
    address: {
      title: "Address",
    },
  },
  footer: {
    description:
      "Your Trusted Transport and Logistics Partner in Europe and the UK",
    contact: {
      title: "Contact",
    },
    quickLinks: {
      title: "Quick Links",
    },
    copyright: "All rights reserved.",
  },
};
